export default __webpack_public_path__ + "static/media/LogoSecondaryWhite.6318fa0a.png";